<template>
  <el-dropdown trigger="click" @visible-change="dropDownIcon" @command="handleCommand">
    <span class="el-dropdown-link" :class="{ bold: isBold }">
      <pp-icon type="ios-world-outline" size="20" class="mgr5" />
      {{ textFont[lang] }}
      <i :class="textIcon" />
    </span>
    <el-dropdown-menu slot="dropdown" class="lang-dropdown">
      <el-dropdown-item :command="elseKey">{{ textFont[elseKey] }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'LangSwitch',
  props: {
    isBold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lang: localStorage.getItem('lang') || (navigator.language.indexOf('zh') > -1? 'zh': 'en'),
      textFont: {
        zh: '中文',
        en: 'EN'
      },
      elseKey: 'en',
      textIcon: 'el-icon-arrow-down el-icon--right'
    }
  },
  created() {
    if (this.lang === 'zh') this.elseKey = 'en'
    else this.elseKey = 'zh'
  },
  methods: {
    dropDownIcon(val) {
      if (val) this.textIcon = 'el-icon-arrow-up el-icon--right'
      else this.textIcon = 'el-icon-arrow-down el-icon--right'
    },
    handleCommand(val) {
      this.lang = val
      // reload page
      localStorage.setItem('lang', val)
      this.setTimeZone()
      setTimeout(() => {
        window.location.reload()
      }, 300)
    },
    setTimeZone() {
      // 设置时区 - 中文默认东八区 英文0时区
      localStorage.setItem('pp-timeZone', this.lang === 'zh'? 'UTC+8': 'UTC+0')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-popper {
    margin-top: 3px;
}
.el-dropdown-link {
	cursor: pointer;
  font-size: 16px;
  color: #666;
  &.bold {
    font-weight: 600;
  }
}
.mgr5 {
    margin-right: 3px;
}
.lang-dropdown {
    padding: 1px;
}
.pp-icon {
	-webkit-text-stroke-width: 0.2px;
  vertical-align: -2px;
}
</style>
